import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { HeartPulse } from "lucide-react";

export const Route = createFileRoute("/ald/")({
  component: ALDPage,
});

function ALDPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <HeartPulse className="h-5 w-5" /> ALD — Affections Longue Durée
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Demandes · Validation · Exonération ticket modérateur</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Module ALD</CardTitle>
          <CardDescription>Liste des 30 ALD prises en charge · Maroc CNOPS/AMO</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Les demandes ALD sont créées depuis la fiche patient → Onglet ALD.
          Le workflow est : Médecin demande → Contrôle médical valide → Exonération appliquée automatiquement à la facturation.
        </CardContent>
      </Card>
    </div>
  );
}
